<script lang="ts" setup>
import type { SwiperContainer } from 'swiper/element'
import type { ScheduleEvent } from '~/types'

defineOptions({
  name: 'TickerSwiper',
})

const SLIDES_PER_VIEW: number = 4

interface Props {
  scheduleEvents: ScheduleEvent.Model[]
}

const props = defineProps<Props>()

const hasEnoughItemsForLoop = computed<boolean>(() => props.scheduleEvents.length > SLIDES_PER_VIEW)

const containerRef = ref<SwiperContainer | null>(null)

useSwiper(containerRef, {
  spaceBetween: 0,
  slidesPerView: 1.2,
  loop: hasEnoughItemsForLoop.value,
  breakpoints: {
    993: {
      slidesPerView: SLIDES_PER_VIEW,
    },
  },
  injectStyles: [
    `
    @media only screen and (max-width: 1279px) {
      :host .swiper {
        width: 100%;
        height: auto;
        overflow: visible;
      }

      :host .swiper-wrapper {
        flex-direction: column;
        height: auto;
        transform: none !important;
      }
    }
    `,
  ],
})
</script>

<template>
  <div class="schedule-events-ticker-swiper">
    <swiper-container
      v-if="scheduleEvents.length"
      ref="containerRef"
      :init="false"
    >
      <swiper-slide
        v-for="scheduleEvent in scheduleEvents"
        :key="`schedule-ticker-item-${scheduleEvent.id}`"
        tag="div"
      >
        <ScheduleEventsTickerItem
          :schedule-event
          class="schedule-events-ticker-swiper__item"
        />
      </swiper-slide>
    </swiper-container>
  </div>
</template>

<style scoped lang="scss">
.schedule-events-ticker-swiper {
  @apply w-full;

  swiper-slide {
    @apply w-full !important;
    @apply xl:w-1/4 !important;

    &:nth-child(4n) :deep(.schedule-ticker-event__inner) {
      @apply xl:border-r-0;
    }
  }

  swiper-container {
    @apply h-[calc(100vh-150px)] overflow-auto pb-[100px];
    @apply xl:h-full xl:overflow-hidden xl:pb-0;
  }
}
</style>
